import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import FilterableTableLayout from "../../../../components/FilterableTableLayout/FilterableTableLayout";
import { PersistedFilterKeys } from "../../../../modules/filters/filters.types";
import {
  getPeriodicReportListFilterItems,
  getPeriodicReportTableColumns,
  PERIODIC_REPORT_LIST_INITIAL_FILTERS,
  PERIODIC_REPORT_LIST_INITIAL_PAGINATION,
} from "../../../../modules/obligee/periodicReports/periodicReport.constants";
import { usePeriodicReportList } from "../../../../modules/obligee/periodicReports/periodicReport.queries";
import {
  PeriodicReport,
  PeriodicReportListFilterPayload,
  PeriodicReportListQueryResponse,
} from "../../../../modules/obligee/periodicReports/periodicReports.types";

const PeriodicReportListPage = () => {
  const navigate = useNavigate();

  const onDetailClickHandler = (periodicReport: PeriodicReport) => {
    navigate(
      `/mfin/periodicniIzvestaji/detalji?periodId=${periodicReport.periodId}&pib=${periodicReport.drustvoPib}`
    );
  };

  return (
    <FilterableTableLayout<
      PeriodicReport,
      PeriodicReportListQueryResponse,
      PeriodicReportListFilterPayload
    >
      tableName="periodic_report_table"
      toolbarId="periodic_report_list"
      title={t("PERIODICNI_IZVESTAJI.PERIODICNI_IZVESTAJI")}
      getTableColumns={() =>
        getPeriodicReportTableColumns({ onDetailClickHandler })
      }
      queryHook={usePeriodicReportList}
      tableRowKey="id"
      onTableRowClick={(record: PeriodicReport) => onDetailClickHandler(record)}
      filterProps={{
        getFilterItems: getPeriodicReportListFilterItems,
        initialFilters: PERIODIC_REPORT_LIST_INITIAL_FILTERS,
        persistedFilterKey: PersistedFilterKeys.PERIODIC_REPORT_LIST,
      }}
      dataListKey="list"
      paginationProps={{
        enableAPIPagination: true,
        initialPagination: PERIODIC_REPORT_LIST_INITIAL_PAGINATION,
        totalCountKey: "total",
      }}
    />
  );
};

export default PeriodicReportListPage;
